import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.string.iterator";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.find-index";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { API_REQUEST } from '@/api/';
import { getFullTime } from '@/modules/mm-utils.js';
var state = {
  items: [],
  refresh: 0,
  calculateTemplate: '',
  shiftPatternOptions: [],
  loadTemplateOptions: [],
  departmentInfo: {},
  workTypes: [],
  regions: []
};
var mutations = {
  setItems: function setItems(state, value) {
    state.items = value;
  },
  refresh: function refresh(state) {
    state.refresh++;
  },
  changeItem: function changeItem(state, data) {
    var index = state.items.findIndex(function (item) {
      return item.id === data.id;
    });

    if (index > -1) {
      Object.assign(state.items[index], data);
    }
  },
  setCalculateTemplate: function setCalculateTemplate(state, value) {
    state.calculateTemplate = value[1];
  },
  setLoadTemplateOptions: function setLoadTemplateOptions(state, payload) {
    state.loadTemplateOptions = payload;
  },
  setShiftPatternOptions: function setShiftPatternOptions(state, payload) {
    state.shiftPatternOptions = payload;
  },
  setDepartmentInfo: function setDepartmentInfo(state, payload) {
    state.departmentInfo = payload;
  },
  setWorkTypes: function setWorkTypes(state, payload) {
    state.workTypes = payload;
  },
  setRegions: function setRegions(state, payload) {
    state.regions = payload;
  }
};

function newApiMethodAndParams(_ref) {
  var apiMethod = _ref.apiMethod,
      subject = _ref.subject,
      params = _ref.params,
      get = _ref.get;
  var newParams = params;
  var newApiMethod = apiMethod;
  var additionalParams = {
    Operation: {
      'do_forecast': 'F',
      'no_work_type': true
    },
    BusinessDriver: {
      'do_forecast': 'H'
    },
    WorkType: {
      'no_work_type': false
    }
  };

  if (Object.keys(additionalParams).includes(subject)) {
    var method = get === true ? 'get' : params.id === '-1' ? 'create' : 'update';
    newApiMethod = method + (subject === 'WorkType' ? 'WorkTypeName' : 'OperationTypeName');
    newParams = _objectSpread(_objectSpread({}, params), additionalParams[subject]);
  }

  return {
    newApiMethod: newApiMethod,
    newParams: newParams
  };
}

var actions = {
  saveDep: function saveDep(_ref2, _ref3) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, data, apiMethod, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit;
              data = _ref3.data;
              apiMethod = data['id'] === '-1' ? 'createDepartment' : 'updateDepartment';
              _context.next = 5;
              return API_REQUEST(apiMethod, data);

            case 5:
              res = _context.sent;

              if (!res[1]) {
                _context.next = 13;
                break;
              }

              _context.t0 = data['id'];
              _context.next = _context.t0 === '-1' ? 10 : 12;
              break;

            case 10:
              commit('refresh');
              return _context.abrupt("break", 13);

            case 12:
              commit('cachedData/updateDepartment', res[1], {
                root: true
              });

            case 13:
              return _context.abrupt("return", res);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  saveItem: function saveItem(_ref4, _ref5) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, data, subject, apiMethod, _newApiMethodAndParam, newApiMethod, newParams, res;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit;
              data = _ref5.data, subject = _ref5.subject;
              apiMethod = data['id'] === '-1' ? 'create' + subject : 'update' + subject;
              _newApiMethodAndParam = newApiMethodAndParams({
                apiMethod: apiMethod,
                subject: subject,
                params: data,
                get: false
              }), newApiMethod = _newApiMethodAndParam.newApiMethod, newParams = _newApiMethodAndParam.newParams;
              _context2.next = 6;
              return API_REQUEST(newApiMethod, newParams);

            case 6:
              res = _context2.sent;

              if (!res[1]) {
                _context2.next = 14;
                break;
              }

              _context2.t0 = data['id'];
              _context2.next = _context2.t0 === '-1' ? 11 : 13;
              break;

            case 11:
              commit('refresh');
              return _context2.abrupt("break", 14);

            case 13:
              commit('changeItem', res[1]);

            case 14:
              return _context2.abrupt("return", res);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  fetchRegions: function fetchRegions(_ref6) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _state$regions;

      var commit, _yield$API_REQUEST, _yield$API_REQUEST2, error, regions;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref6.commit;

              if (!((_state$regions = state.regions) !== null && _state$regions !== void 0 && _state$regions.length)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", state.regions);

            case 3:
              _context3.next = 5;
              return API_REQUEST('getRegions');

            case 5:
              _yield$API_REQUEST = _context3.sent;
              _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
              error = _yield$API_REQUEST2[0];
              regions = _yield$API_REQUEST2[1];

              if (!error) {
                _context3.next = 11;
                break;
              }

              return _context3.abrupt("return", false);

            case 11:
              commit('setRegions', regions);
              return _context3.abrupt("return", regions);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  updateItems: function updateItems(_ref7, _ref8) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, pageNumber, limit, subject, params, offset, apiMethod, _newApiMethodAndParam2, newApiMethod, newParams, answer, res;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref7.commit;
              pageNumber = _ref8.pageNumber, limit = _ref8.limit, subject = _ref8.subject, params = _ref8.params;
              offset = (pageNumber - 1) * limit;
              apiMethod = 'get' + subject;
              params = _objectSpread({
                offset: offset,
                limit: limit
              }, params);
              _newApiMethodAndParam2 = newApiMethodAndParams({
                apiMethod: apiMethod,
                subject: subject,
                params: params,
                get: true
              }), newApiMethod = _newApiMethodAndParam2.newApiMethod, newParams = _newApiMethodAndParam2.newParams;
              _context4.next = 8;
              return API_REQUEST(newApiMethod, newParams);

            case 8:
              answer = _context4.sent;
              res = answer[1];

              if (!res) {
                _context4.next = 14;
                break;
              }

              commit('setItems', res.results);
              commit('application/setPrimaryPageLoaded', {
                value: true
              }, {
                root: true
              });
              return _context4.abrupt("return", {
                count: res.count
              });

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  calculateTemplate: function calculateTemplate(_ref9, body) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var commit, res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref9.commit;
              _context5.next = 3;
              return API_REQUEST('calculateTemplate', body);

            case 3:
              res = _context5.sent;
              commit('setCalculateTemplate', res);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  getDepartmentSchedule: function getDepartmentSchedule(_ref10, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var commit, res, finalData;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref10.commit;
              _context6.next = 3;
              return API_REQUEST('getDepartmentSchedule', params);

            case 3:
              res = _context6.sent;

              if (res[1]) {
                _context6.next = 6;
                break;
              }

              return _context6.abrupt("return", false);

            case 6:
              finalData = {};
              res[1].forEach(function (day) {
                finalData[day.dt] = _objectSpread(_objectSpread({}, day), {}, {
                  draftOpens: day.opens,
                  draftCloses: day.closes,
                  draftType: day.type
                });
              });
              return _context6.abrupt("return", finalData);

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  },
  updateDepartmentSchedule: function updateDepartmentSchedule(_ref11, body) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var commit, res;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref11.commit;
              body.opens = getFullTime(body.opens);
              body.closes = getFullTime(body.closes);
              _context7.next = 5;
              return API_REQUEST('updateDepartmentSchedule', body);

            case 5:
              res = _context7.sent;
              return _context7.abrupt("return", res[1]);

            case 7:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  },
  fetchAutoschedulingSettingsData: function fetchAutoschedulingSettingsData(_ref12, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var dispatch;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              dispatch = _ref12.dispatch;
              _context8.next = 3;
              return Promise.all([dispatch('fetchDepartmentInfo', params), dispatch('fetchTimetableTemplate')]);

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  },
  fetchDataForCalculationOfTheNeed: function fetchDataForCalculationOfTheNeed(_ref13, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      var dispatch;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              dispatch = _ref13.dispatch;
              _context9.next = 3;
              return Promise.all([dispatch('fetchDepartmentInfo', params), dispatch('fetchLoadTemplate')]);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }))();
  },
  fetchTimetableTemplate: function fetchTimetableTemplate(_ref14) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var commit, _yield$API_REQUEST3, _yield$API_REQUEST4, err, items, shiftPatternOptions;

      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref14.commit;
              _context10.prev = 1;
              _context10.next = 4;
              return API_REQUEST('getTimetableTemplate');

            case 4:
              _yield$API_REQUEST3 = _context10.sent;
              _yield$API_REQUEST4 = _slicedToArray(_yield$API_REQUEST3, 2);
              err = _yield$API_REQUEST4[0];
              items = _yield$API_REQUEST4[1];

              if (!err) {
                _context10.next = 10;
                break;
              }

              throw err;

            case 10:
              shiftPatternOptions = items.map(function (item) {
                return {
                  value: item.id,
                  label: item.name
                };
              });
              commit('setShiftPatternOptions', shiftPatternOptions);
              _context10.next = 18;
              break;

            case 14:
              _context10.prev = 14;
              _context10.t0 = _context10["catch"](1);
              console.log('Unable to fetch timetable templates:', _context10.t0.message);
              console.error(_context10.t0);

            case 18:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[1, 14]]);
    }))();
  },
  fetchLoadTemplate: function fetchLoadTemplate(_ref15) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var commit, _yield$API_REQUEST5, _yield$API_REQUEST6, err, items, loadTemplateOptions;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref15.commit;
              _context11.prev = 1;
              _context11.next = 4;
              return API_REQUEST('getLoadTemplate');

            case 4:
              _yield$API_REQUEST5 = _context11.sent;
              _yield$API_REQUEST6 = _slicedToArray(_yield$API_REQUEST5, 2);
              err = _yield$API_REQUEST6[0];
              items = _yield$API_REQUEST6[1];

              if (!err) {
                _context11.next = 10;
                break;
              }

              throw err;

            case 10:
              loadTemplateOptions = items.map(function (item) {
                return {
                  value: item.id,
                  label: item.name
                };
              });
              commit('setLoadTemplateOptions', loadTemplateOptions);
              _context11.next = 18;
              break;

            case 14:
              _context11.prev = 14;
              _context11.t0 = _context11["catch"](1);
              console.log('Unable to fetch load templates:', _context11.t0.message);
              console.error(_context11.t0);

            case 18:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, null, [[1, 14]]);
    }))();
  },
  fetchDepartmentInfo: function fetchDepartmentInfo(_ref16, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      var _state$departmentInfo;

      var commit, state, _yield$API_REQUEST7, _yield$API_REQUEST8, err, depInfo;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              commit = _ref16.commit, state = _ref16.state;

              if (!((_state$departmentInfo = state.departmentInfo) !== null && _state$departmentInfo !== void 0 && _state$departmentInfo.id)) {
                _context12.next = 3;
                break;
              }

              return _context12.abrupt("return");

            case 3:
              _context12.prev = 3;
              _context12.next = 6;
              return API_REQUEST('getDepartmentInfo', params);

            case 6:
              _yield$API_REQUEST7 = _context12.sent;
              _yield$API_REQUEST8 = _slicedToArray(_yield$API_REQUEST7, 2);
              err = _yield$API_REQUEST8[0];
              depInfo = _yield$API_REQUEST8[1];

              if (!err) {
                _context12.next = 12;
                break;
              }

              throw err;

            case 12:
              commit('setDepartmentInfo', depInfo);
              _context12.next = 19;
              break;

            case 15:
              _context12.prev = 15;
              _context12.t0 = _context12["catch"](3);
              console.log('Unable to fetch Department info:', _context12.t0.message);
              console.error(_context12.t0);

            case 19:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, null, [[3, 15]]);
    }))();
  },
  fetchWorkTypes: function fetchWorkTypes(_ref17, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
      var commit, _yield$API_REQUEST9, _yield$API_REQUEST10, err, wTypes;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              commit = _ref17.commit;
              _context13.prev = 1;
              _context13.next = 4;
              return API_REQUEST('getWorkTypes', params);

            case 4:
              _yield$API_REQUEST9 = _context13.sent;
              _yield$API_REQUEST10 = _slicedToArray(_yield$API_REQUEST9, 2);
              err = _yield$API_REQUEST10[0];
              wTypes = _yield$API_REQUEST10[1];

              if (!err) {
                _context13.next = 10;
                break;
              }

              throw err;

            case 10:
              commit('setWorkTypes', wTypes);
              _context13.next = 17;
              break;

            case 13:
              _context13.prev = 13;
              _context13.t0 = _context13["catch"](1);
              console.log('Unable to fetch Department info:', _context13.t0.message);
              console.error(_context13.t0);

            case 17:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, null, [[1, 13]]);
    }))();
  },
  saveWorkTypes: function saveWorkTypes(_, workTypes) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      var _iterator, _step, wType, _yield$API_REQUEST11, _yield$API_REQUEST12, err;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _iterator = _createForOfIteratorHelper(workTypes);
              _context14.prev = 2;

              _iterator.s();

            case 4:
              if ((_step = _iterator.n()).done) {
                _context14.next = 15;
                break;
              }

              wType = _step.value;
              _context14.next = 8;
              return API_REQUEST('workTypesUpdate', wType);

            case 8:
              _yield$API_REQUEST11 = _context14.sent;
              _yield$API_REQUEST12 = _slicedToArray(_yield$API_REQUEST11, 1);
              err = _yield$API_REQUEST12[0];

              if (!err) {
                _context14.next = 13;
                break;
              }

              throw err;

            case 13:
              _context14.next = 4;
              break;

            case 15:
              _context14.next = 20;
              break;

            case 17:
              _context14.prev = 17;
              _context14.t0 = _context14["catch"](2);

              _iterator.e(_context14.t0);

            case 20:
              _context14.prev = 20;

              _iterator.f();

              return _context14.finish(20);

            case 23:
              return _context14.abrupt("return", true);

            case 26:
              _context14.prev = 26;
              _context14.t1 = _context14["catch"](0);
              console.log('Unable to save work types:', _context14.t1.message);
              console.error(_context14.t1);
              return _context14.abrupt("return", false);

            case 31:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, null, [[0, 26], [2, 17, 20, 23]]);
    }))();
  },
  updateDepartment: function updateDepartment(_, depInfo) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      var _yield$API_REQUEST13, _yield$API_REQUEST14, err;

      return _regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return API_REQUEST('updateDepartment', depInfo);

            case 3:
              _yield$API_REQUEST13 = _context15.sent;
              _yield$API_REQUEST14 = _slicedToArray(_yield$API_REQUEST13, 1);
              err = _yield$API_REQUEST14[0];

              if (!err) {
                _context15.next = 8;
                break;
              }

              throw err;

            case 8:
              return _context15.abrupt("return", true);

            case 11:
              _context15.prev = 11;
              _context15.t0 = _context15["catch"](0);
              console.log('Unable to save department:', _context15.t0.message);
              console.error(_context15.t0);
              return _context15.abrupt("return", false);

            case 16:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, null, [[0, 11]]);
    }))();
  },
  updateDepLoadTemplate: function updateDepLoadTemplate(_, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
      var _yield$API_REQUEST15, _yield$API_REQUEST16, err;

      return _regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              _context16.next = 3;
              return API_REQUEST('updateDepLoadTemplate', params);

            case 3:
              _yield$API_REQUEST15 = _context16.sent;
              _yield$API_REQUEST16 = _slicedToArray(_yield$API_REQUEST15, 1);
              err = _yield$API_REQUEST16[0];

              if (!err) {
                _context16.next = 8;
                break;
              }

              throw err;

            case 8:
              return _context16.abrupt("return", true);

            case 11:
              _context16.prev = 11;
              _context16.t0 = _context16["catch"](0);
              console.log('Unable to save load template:', _context16.t0.message);
              console.error(_context16.t0);
              return _context16.abrupt("return", false);

            case 16:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, null, [[0, 11]]);
    }))();
  },
  addIPAddress: function addIPAddress(_, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      var _yield$API_REQUEST17, _yield$API_REQUEST18, err;

      return _regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              _context17.next = 3;
              return API_REQUEST('addIPAddress', params);

            case 3:
              _yield$API_REQUEST17 = _context17.sent;
              _yield$API_REQUEST18 = _slicedToArray(_yield$API_REQUEST17, 1);
              err = _yield$API_REQUEST18[0];

              if (!err) {
                _context17.next = 8;
                break;
              }

              throw err;

            case 8:
              return _context17.abrupt("return", true);

            case 11:
              _context17.prev = 11;
              _context17.t0 = _context17["catch"](0);
              console.log('Unable to add IP address list:', _context17.t0.message);
              console.error(_context17.t0);
              return _context17.abrupt("return", false);

            case 16:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, null, [[0, 11]]);
    }))();
  },
  deleteIPAddress: function deleteIPAddress(_, params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      var _yield$API_REQUEST19, _yield$API_REQUEST20, err;

      return _regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return API_REQUEST('deleteIPAddress', {
                id: params.id
              });

            case 3:
              _yield$API_REQUEST19 = _context18.sent;
              _yield$API_REQUEST20 = _slicedToArray(_yield$API_REQUEST19, 1);
              err = _yield$API_REQUEST20[0];

              if (!err) {
                _context18.next = 8;
                break;
              }

              throw err;

            case 8:
              return _context18.abrupt("return", true);

            case 11:
              _context18.prev = 11;
              _context18.t0 = _context18["catch"](0);
              console.error(_context18.t0);
              return _context18.abrupt("return", false);

            case 15:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, null, [[0, 11]]);
    }))();
  }
};
var getters = {
  getShiftPatternOptions: function getShiftPatternOptions(state) {
    return state.shiftPatternOptions;
  },
  getLoadTemplateOptions: function getLoadTemplateOptions(state) {
    return state.loadTemplateOptions;
  },
  getDepartmentInfo: function getDepartmentInfo(state) {
    return state.departmentInfo;
  },
  getWorkTypes: function getWorkTypes(state) {
    return state.workTypes;
  },
  getRegions: function getRegions(state) {
    return state.regions;
  }
};
export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  getters: getters,
  state: state
};